import React from 'react'

const HeaderSocials = () => {
  return (
    <div className="home__socials">
        <a href="https://www.linkedin.com/in/gordenyong/" className="home__social-link" target="_blank">
        <i class="fa-brands fa-linkedin"></i>    
        </a>

        <a href="https://github.com/gordenyong" className="home__social-link" target="_blank">
        <i class="fa-brands fa-github"></i>    
        </a>

        <a href="https://www.instagram.com/gorden_yong/" className="home__social-link" target="_blank">
        <i class="fa-brands fa-instagram"></i>    
        </a>
    </div>
  )
}

export default HeaderSocials